import React from "react";
import { Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getLayoutMaxWidth } from "src/theme/layout";

/**
 * Container capped to a Treffas layout width (not an MUI breakpoint).
 *
 * @param {object} props
 * @param {string} props.layout - Layout key or legacy name (e.g. "posts", "posts_container", "bp")
 */
const TreffasContainer = React.forwardRef(function TreffasContainer(
  { layout, sx, ...props },
  ref
) {
  const theme = useTheme();
  const maxWidth = getLayoutMaxWidth(theme, layout);

  return (
    <Container
      ref={ref}
      maxWidth={false}
      sx={[{ maxWidth, width: "100%" }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    />
  );
});

export default TreffasContainer;
